// src/pages/AdminDashboardPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaBoxOpen, FaUsers, FaShoppingBag, FaChartLine, FaPercentage } from "react-icons/fa";
import PageHeader from "../components/PageHeader";

function AdminDashboardPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // Access control is handled by ProtectedAdminRoute (server-side role validation)


  return (
    <div className="min-h-screen bg-[#FCFAED] pt-24 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <PageHeader
          title={t("admin.dashboard_title")}
          subtitle={t("admin.dashboard_subtitle")}
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Carte Gestion des Produits */}
          <div 
            onClick={() => navigate("/produit")}
            className="bg-white rounded-3xl p-8 shadow-xl border-2 border-transparent hover:border-[var(--primary-color)] transition-all cursor-pointer group flex flex-col items-center text-center transform hover:-translate-y-2"
          >
            <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
              <FaBoxOpen className="text-4xl text-amber-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">{t("admin.manage_products")}</h3>
            <p className="text-gray-500 mb-6">{t("admin.manage_products_desc")}</p>
            <button className="mt-auto px-6 py-2 bg-amber-50 text-amber-700 font-semibold rounded-lg group-hover:bg-[var(--primary-color)] group-hover:text-white transition-colors w-full">
              {t("admin.manage_products_btn")}
            </button>
          </div>

          {/* Carte Gestion des Commandes */}
          <div 
            onClick={() => navigate("/admin/orders")}
            className="bg-white rounded-3xl p-8 shadow-xl border-2 border-transparent hover:border-[var(--secondary-color)] transition-all cursor-pointer group flex flex-col items-center text-center transform hover:-translate-y-2"
          >
            <div className="w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-100 transition-colors">
              <FaShoppingBag className="text-4xl text-blue-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">{t("admin.manage_orders")}</h3>
            <p className="text-gray-500 mb-6">{t("admin.manage_orders_desc")}</p>
            <button className="mt-auto px-6 py-2 bg-blue-50 text-blue-700 font-semibold rounded-lg group-hover:bg-[var(--secondary-color)] group-hover:text-white transition-colors w-full">
              {t("admin.manage_orders_btn")}
            </button>
          </div>

          {/* Carte Gestion des Utilisateurs */}
          <div 
            onClick={() => navigate("/admin/users")}
            className="bg-white rounded-3xl p-8 shadow-xl border-2 border-transparent hover:border-purple-500 transition-all cursor-pointer group flex flex-col items-center text-center transform hover:-translate-y-2"
          >
            <div className="w-20 h-20 bg-purple-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-purple-100 transition-colors">
              <FaUsers className="text-4xl text-purple-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">{t("admin.manage_users")}</h3>
            <p className="text-gray-500 mb-6">{t("admin.manage_users_desc")}</p>
            <button className="mt-auto px-6 py-2 bg-purple-50 text-purple-700 font-semibold rounded-lg group-hover:bg-purple-600 group-hover:text-white transition-colors w-full">
              {t("admin.manage_users_btn")}
            </button>
          </div>

          {/* Carte Gestion des Packs & Promotions */}
          <div 
            onClick={() => navigate("/admin/packs")}
            className="bg-white rounded-3xl p-8 shadow-xl border-2 border-transparent hover:border-[var(--secondary-color)] transition-all cursor-pointer group flex flex-col items-center text-center transform hover:-translate-y-2"
          >
            <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
              <FaPercentage className="text-4xl text-amber-600" />
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">{t("admin.manage_packs") || "Packs & Promotions"}</h3>
            <p className="text-gray-500 mb-6">{t("admin.manage_packs_desc") || "Gérez vos remises, packs de produits et bannières dynamiques."}</p>
            <button className="mt-auto px-6 py-2 bg-amber-50 text-amber-700 font-semibold rounded-lg group-hover:bg-[var(--secondary-color)] group-hover:text-white transition-colors w-full">
              {t("admin.manage_packs_btn") || "Gérer les offres"}
            </button>
          </div>

        </div>

        {/* Section optionnelle Statistiques visuelles */}
        <div className="mt-12 bg-gradient-to-r from-[var(--primary-color)] to-[var(--secondary-color)] rounded-3xl p-8 shadow-lg text-white flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold flex items-center gap-3">
              <FaChartLine /> {t("admin.quick_overview")}
            </h2>
            <p className="opacity-90 mt-2">{t("admin.quick_overview_desc")}</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AdminDashboardPage;
